



import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { backendUrl, currency } from '../App';
import { toast } from 'react-toastify';
import { assets } from '../assets/assets';
import 'bootstrap/dist/css/bootstrap.min.css';

const Orders = ({ token }) => {
    const [orders, setOrders] = useState([]);

    const fetchAllOrders = async () => {
        if (!token) return;

        try {
            const response = await axios.post(`${backendUrl}/api/order/list`, {}, { headers: { token } });
            if (response.data.success) {
                setOrders(response.data.orders);
            } else {
                toast.error(response.data.message);
            }
        } catch (error) {
            toast.error(error.message);
        }
    };

    const statusHandler = async (event, orderId) => {
        try {
            const response = await axios.post(
                `${backendUrl}/api/order/status`,
                { orderId, status: event.target.value },
                { headers: { token } }
            );

            if (response.data.success) {
                await fetchAllOrders();
            }
        } catch (error) {
            toast.error(error.message);
        }
    };

    useEffect(() => {
        fetchAllOrders();
    }, [token]);

    return (
        <div className="container mt-4">
            <h3>Order Page</h3>
            <div>
                {orders.map((order, index) => (
                    <div className="row border p-3 my-3 align-items-center" key={index}>
                        <div className="col-12 col-sm-2 text-center">
                            <img className="img-fluid w-50" src={assets.parcel_icon} alt="Parcel" />
                        </div>
                        <div className="col-12 col-sm-4">
                            <div>
                                {order.items.map((item, idx) => (
                                    <p key={idx} className="mb-1">
                                        {item.name} x {item.quantity} <span>{item.size}</span>
                                        {idx !== order.items.length - 1 ? ',' : ''}
                                    </p>
                                ))}
                            </div>
                            <p className="mt-3 mb-2 fw-bold">{order.address.firstName} {order.address.lastName}</p>
                            <p>{order.address.street},</p>
                            <p>{order.address.city}, {order.address.state}, {order.address.country}, {order.address.zipcode}</p>
                            <p>{order.address.phone}</p>
                        </div>
                        <div className="col-12 col-sm-2">
                            <p className="fw-bold">Items: {order.items.length}</p>
                            <p>Method: {order.paymentMethod}</p>
                            <p>Payment: {order.payment ? 'Done' : 'Pending'}</p>
                            <p>Date: {new Date(order.date).toLocaleDateString()}</p>
                        </div>
                        <div className="col-12 col-sm-2">
                            <p className="fw-bold">{currency}{order.amount}</p>
                        </div>
                        <div className="col-12 col-sm-2 text-end">
                            <select className="form-select d-inline-block w-auto" onChange={(event) => statusHandler(event, order._id)} value={order.status}>
                                <option value="Order Placed">Order Placed</option>
                                <option value="Packing">Packing</option>
                                <option value="Shipped">Shipped</option>
                                <option value="Out for delivery">Out for delivery</option>
                                <option value="Delivered">Delivered</option>
                            </select>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default Orders;

